
import React, { useEffect } from 'react';
import { get_cdn_doc } from '../../services/projectservice.js'
import { TTDoc } from '../routes/editor/tiptap/TipTapViewer.jsx';
import { useOutletContext } from "react-router-dom";
import { ConfigContext } from '../../ConfigContext';
import { useContext } from 'react';


export default function ArtistStatement()  {
    
        const { bootstrapConfig } = useContext(ConfigContext); 

        const [tiptapData, setTiptapData] = React.useState(null);
        const [loadError, setLoadError] = React.useState('');
            
        const handleLoad = (data) => {
            setTiptapData(data.data);
        }
    
        const handleLoadError = (error) => {
            console.error("Error loading data:", error);
            setLoadError(`Error loading data: ${error}`);
        }
    
        useEffect(() => { 
            if (bootstrapConfig && Object.keys(bootstrapConfig).length) {
                get_cdn_doc(bootstrapConfig.artiststatement_doc_id, handleLoad, handleLoadError) 
            } 
        }, [bootstrapConfig]);

        return (<> 
            <h1>Artist Statement</h1>
            <p>dynamic config fetched once for the root context:</p>
            <pre>{ Object.keys(bootstrapConfig).length && JSON.stringify(bootstrapConfig)}</pre>
            { (tiptapData && Object.keys(tiptapData).length ) && <TTDoc ttData={tiptapData} />} 
        </>) 
    
}